(function() {
    'use strict';
    /*
     * Copyright (c) 2014-2019 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('campaignPrescriptions', campaignPrescriptions);

    function campaignPrescriptions() {
        return {
            restrict: 'AE',
            transclude: true,
            scope: {
                /**
                 * If provided, the campaign is within the scope of this clinic; otherwise it is an IHH campaign.
                 */
                clinic: '=',

                /**
                 * If in a clinic scope, the ID of the therapist user doing the editing.
                 */
                therapistId: '=',

                /**
                 * A chooser config already initialized for picking campaign prescription exercises.
                 */
                exercisesConfig: '=',

                /**
                 * A chooser config already initialized for picking campaign prescription exercise templates.
                 */
                exerciseTemplatesConfig: '=',

                /**
                 * A chooser config already initialized for picking campaign presription protocols.
                 */
                protocolsConfig: '=',

                /**
                 * An object with methods to query, create, read, update, and delete campaign prescriptions.
                 */
                prescriptionsCrud: '=',

                episodeModel: '=',

                /**
                 * If provided, a function(clinic, featureString) that answers whether the clinic has that feature flag enabled.
                 */
                hasClinicFeature: '=',

                /**
                 * Indicates whether the campaign prescriptions are read only.
                 */
                isReadOnly: '='
            },
            controller: 'CampaignPrescriptionsCtrl',
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'campaign-prescriptions/campaign-prescriptions.tpl.html'
        };
    }
})();
